
import type { CloudImage } from "~/types/CloudImage";
import type { TreeNode } from "~/types/tasks";

export const createTree = (paths: string[]): any[] => {
  const buildTree = (paths: string[], parentPath: string = ""): any[] => {
    const tree: any[] = [];

    const groupedPaths = paths.reduce((acc, path) => {
      const [head, ...tail] = path.replace(parentPath, "").split("/").filter(Boolean);
      if (!head) return acc;
      acc[head] = acc[head] || [];
      acc[head].push(tail.join("/"));
      return acc;
    }, {} as Record<string, string[]>);

    for (const [key, subPaths] of Object.entries(groupedPaths)) {
      tree.push({
        name: key,
        children: buildTree(subPaths, `${parentPath}${key}/`),
        path: `${parentPath}${key}/`,
      });
    }

    return tree;
  };

  return buildTree(paths);
};

export const addFilesToTree = (tree: any[], files: CloudImage[]): any[] => {
  

  const addItems = (nodes: any[]): any[] => {
    return nodes.map((node) => {
      if (node.children.length === 0) {
        node.items = files.filter((file) => file.fullImageName ? file.fullImageName.includes(node.path) : file.name.includes(node.path));
      } else {
        node.children = addItems(node.children);
      }
      return node;
    });
  };

  return addItems(tree);
}

export const folderFilesCount = (node: TreeNode): number => {
  let count = 0;
  const countFiles = (node: TreeNode): void => {
    if (node.children && node.children.length) {
      const nodes = node.children;
      nodes.forEach((child: TreeNode) => {
        if (child.children) {
          countFiles(child);
        }
        else if (child.items && child.items.length) {
          count += child.items.length;
        }
 
      });
    } else if (node.items && node.items.length) {
      count += node.items.length;
    }
  };
  countFiles(node);
  return count;
}

export const getAllItemsFromNode = (node: TreeNode): any[] => {
  let items: any[] = [];
  const collectItems = (node: TreeNode): void => {
    if (node.children && node.children.length) {
      node.children.forEach((child: TreeNode) => {
        collectItems(child);
      });
    } else if (node.items && node.items.length) {
      items = items.concat(node.items);
    }
  };
  collectItems(node);
  return items;
}

export const getFoldersByString = (string: string, folderStructure: TreeNode[]) =>
  folderStructure &&
  folderStructure.filter(folder => folder.path && folder.path.includes(string));

